<template>
  <ul class="dropdown-group">
    <li class="dropdown-group-header">{{header}}</li>
    <slot/>
  </ul>
</template>

<script>
export default {
  name: 'DropdownGroup',

  props: {
    header: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  .dropdown-group {
    list-style-type: none;
    padding: 0;
    margin: 0;

    .dropdown-group-header {
      cursor: default;
      user-select: none;

      font-family: 'Sitka Small', serif;
      font-size: 0.8rem;
      font-weight: bold;
      text-align: left;

      padding: 0.375rem 1.25rem;

      color: black;

      transition: background-color 350ms ease, color 350ms ease;
    }

    &:first-child {
      padding-top: 0.625rem;
    }

    &:last-child {
      padding-bottom: 0.625rem;
    }
  }

  .dropdown-divider+.dropdown-group {
    padding-top: 0.125rem;
  }
</style>
